import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7e60e589 = () => interopDefault(import('../themes/ecaterix/pages/index.vue' /* webpackChunkName: "themes/ecaterix/pages/index" */))
const _ef8fc2a2 = () => interopDefault(import('../themes/ecaterix/pages/404.vue' /* webpackChunkName: "themes/ecaterix/pages/404" */))
const _e3692372 = () => interopDefault(import('../themes/ecaterix/pages/about/index.vue' /* webpackChunkName: "themes/ecaterix/pages/about/index" */))
const _dbf3be4e = () => interopDefault(import('../themes/ecaterix/pages/articles/index.vue' /* webpackChunkName: "themes/ecaterix/pages/articles/index" */))
const _6bcb89e8 = () => interopDefault(import('../themes/ecaterix/pages/brands/index.vue' /* webpackChunkName: "themes/ecaterix/pages/brands/index" */))
const _65b7751a = () => interopDefault(import('../themes/ecaterix/pages/career/index.vue' /* webpackChunkName: "themes/ecaterix/pages/career/index" */))
const _09408b6f = () => interopDefault(import('../themes/ecaterix/pages/contacts/index.vue' /* webpackChunkName: "themes/ecaterix/pages/contacts/index" */))
const _7916fb88 = () => interopDefault(import('../themes/ecaterix/pages/feedbacks/index.vue' /* webpackChunkName: "themes/ecaterix/pages/feedbacks/index" */))
const _2f58140c = () => interopDefault(import('../themes/ecaterix/pages/gallery/index.vue' /* webpackChunkName: "themes/ecaterix/pages/gallery/index" */))
const _16822dcd = () => interopDefault(import('../themes/ecaterix/pages/logistics/index.vue' /* webpackChunkName: "themes/ecaterix/pages/logistics/index" */))
const _678c59c7 = () => interopDefault(import('../themes/ecaterix/pages/partners/index.vue' /* webpackChunkName: "themes/ecaterix/pages/partners/index" */))
const _4a0f5aec = () => interopDefault(import('../themes/ecaterix/pages/ui-kit-demo.vue' /* webpackChunkName: "themes/ecaterix/pages/ui-kit-demo" */))
const _cd7bfd5a = () => interopDefault(import('../themes/ecaterix/pages/want-to-order/index.vue' /* webpackChunkName: "themes/ecaterix/pages/want-to-order/index" */))
const _7287a761 = () => interopDefault(import('../themes/ecaterix/pages/about/types.js' /* webpackChunkName: "themes/ecaterix/pages/about/types" */))
const _33794ae2 = () => interopDefault(import('../themes/ecaterix/pages/articles/types.js' /* webpackChunkName: "themes/ecaterix/pages/articles/types" */))
const _041cb4fc = () => interopDefault(import('../themes/ecaterix/pages/gallery/types.js' /* webpackChunkName: "themes/ecaterix/pages/gallery/types" */))
const _c7a6fa56 = () => interopDefault(import('../themes/ecaterix/pages/want-to-order/types.js' /* webpackChunkName: "themes/ecaterix/pages/want-to-order/types" */))
const _8cb822ee = () => interopDefault(import('../themes/ecaterix/pages/about/components/AchievementMessage/index.vue' /* webpackChunkName: "themes/ecaterix/pages/about/components/AchievementMessage/index" */))
const _aa829bd2 = () => interopDefault(import('../themes/ecaterix/pages/about/components/Gallery/index.vue' /* webpackChunkName: "themes/ecaterix/pages/about/components/Gallery/index" */))
const _97bf6d32 = () => interopDefault(import('../themes/ecaterix/pages/about/components/HangAchievements/index.vue' /* webpackChunkName: "themes/ecaterix/pages/about/components/HangAchievements/index" */))
const _95a21e28 = () => interopDefault(import('../themes/ecaterix/pages/about/components/MediaInfoBlock/index.vue' /* webpackChunkName: "themes/ecaterix/pages/about/components/MediaInfoBlock/index" */))
const _604c0b5e = () => interopDefault(import('../themes/ecaterix/pages/articles/components/ItemsLarge/index.vue' /* webpackChunkName: "themes/ecaterix/pages/articles/components/ItemsLarge/index" */))
const _6491d3ac = () => interopDefault(import('../themes/ecaterix/pages/articles/components/ItemsSmall/index.vue' /* webpackChunkName: "themes/ecaterix/pages/articles/components/ItemsSmall/index" */))
const _4f17fb4f = () => interopDefault(import('../themes/ecaterix/pages/articles/components/MySkeletonNews/index.vue' /* webpackChunkName: "themes/ecaterix/pages/articles/components/MySkeletonNews/index" */))
const _430d67b6 = () => interopDefault(import('../themes/ecaterix/pages/gallery/components/GalleryItem/index.vue' /* webpackChunkName: "themes/ecaterix/pages/gallery/components/GalleryItem/index" */))
const _61b27a8a = () => interopDefault(import('../themes/ecaterix/pages/logistics/components/ContentImageBlock/index.vue' /* webpackChunkName: "themes/ecaterix/pages/logistics/components/ContentImageBlock/index" */))
const _05bc86be = () => interopDefault(import('../themes/ecaterix/pages/logistics/components/ContentImageBlock/types.js' /* webpackChunkName: "themes/ecaterix/pages/logistics/components/ContentImageBlock/types" */))
const _71a12288 = () => interopDefault(import('../themes/ecaterix/pages/articles/_url/index.vue' /* webpackChunkName: "themes/ecaterix/pages/articles/_url/index" */))
const _54b048f7 = () => interopDefault(import('../themes/ecaterix/pages/gallery/_id/index.vue' /* webpackChunkName: "themes/ecaterix/pages/gallery/_id/index" */))
const _5c2f72a8 = () => interopDefault(import('../themes/ecaterix/pages/product/_product/index.vue' /* webpackChunkName: "themes/ecaterix/pages/product/_product/index" */))
const _5b97444c = () => interopDefault(import('../themes/ecaterix/pages/articles/_url/types.js' /* webpackChunkName: "themes/ecaterix/pages/articles/_url/types" */))
const _4b6bae5c = () => interopDefault(import('../themes/ecaterix/pages/product/_product/types.js' /* webpackChunkName: "themes/ecaterix/pages/product/_product/types" */))
const _1da44d12 = () => interopDefault(import('../themes/ecaterix/pages/articles/_url/components/Banner/index.vue' /* webpackChunkName: "themes/ecaterix/pages/articles/_url/components/Banner/index" */))
const _0b0b63e9 = () => interopDefault(import('../themes/ecaterix/pages/articles/_url/components/Content/index.vue' /* webpackChunkName: "themes/ecaterix/pages/articles/_url/components/Content/index" */))
const _016d8aab = () => interopDefault(import('../themes/ecaterix/pages/articles/_url/components/Video/index.vue' /* webpackChunkName: "themes/ecaterix/pages/articles/_url/components/Video/index" */))
const _79a14bf8 = () => interopDefault(import('../themes/ecaterix/pages/product/_product/components/Characteristics/index.vue' /* webpackChunkName: "themes/ecaterix/pages/product/_product/components/Characteristics/index" */))
const _74f922ef = () => interopDefault(import('../themes/ecaterix/pages/product/_product/components/Product/index.vue' /* webpackChunkName: "themes/ecaterix/pages/product/_product/components/Product/index" */))
const _e93cde8a = () => interopDefault(import('../themes/ecaterix/pages/product/_product/components/Video/index.vue' /* webpackChunkName: "themes/ecaterix/pages/product/_product/components/Video/index" */))
const _8fbc9e86 = () => interopDefault(import('../themes/ecaterix/pages/articles/_url/components/Banner/skeleton.vue' /* webpackChunkName: "themes/ecaterix/pages/articles/_url/components/Banner/skeleton" */))
const _f086d2f4 = () => interopDefault(import('../themes/ecaterix/pages/articles/_url/components/Content/skeleton.vue' /* webpackChunkName: "themes/ecaterix/pages/articles/_url/components/Content/skeleton" */))
const _6fb8e084 = () => interopDefault(import('../themes/ecaterix/pages/articles/_url/components/Video/skeleton.vue' /* webpackChunkName: "themes/ecaterix/pages/articles/_url/components/Video/skeleton" */))
const _09aa201b = () => interopDefault(import('../themes/ecaterix/pages/product/_product/components/Product/components/PanelBoard/index.vue' /* webpackChunkName: "themes/ecaterix/pages/product/_product/components/Product/components/PanelBoard/index" */))
const _554b47f4 = () => interopDefault(import('../themes/ecaterix/pages/product/_product/components/Product/components/ScreenSlider/index.vue' /* webpackChunkName: "themes/ecaterix/pages/product/_product/components/Product/components/ScreenSlider/index" */))
const _21897c16 = () => interopDefault(import('../themes/ecaterix/pages/brands/_.vue' /* webpackChunkName: "themes/ecaterix/pages/brands/_" */))
const _17499616 = () => interopDefault(import('../themes/ecaterix/pages/_.vue' /* webpackChunkName: "themes/ecaterix/pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
  scrollBehavior,

  routes: [{
    path: "/en",
    component: _7e60e589,
    pathToRegexpOptions: {"strict":true},
    name: "index___en"
  }, {
    path: "/ro",
    component: _7e60e589,
    pathToRegexpOptions: {"strict":true},
    name: "index___ro"
  }, {
    path: "/ru",
    component: _7e60e589,
    pathToRegexpOptions: {"strict":true},
    name: "index___ru"
  }, {
    path: "/uk",
    component: _7e60e589,
    pathToRegexpOptions: {"strict":true},
    name: "index___uk"
  }, {
    path: "/en/404",
    component: _ef8fc2a2,
    pathToRegexpOptions: {"strict":true},
    name: "404___en"
  }, {
    path: "/en/about",
    component: _e3692372,
    pathToRegexpOptions: {"strict":true},
    name: "about___en"
  }, {
    path: "/en/articles",
    component: _dbf3be4e,
    pathToRegexpOptions: {"strict":true},
    name: "articles___en"
  }, {
    path: "/en/brands",
    component: _6bcb89e8,
    pathToRegexpOptions: {"strict":true},
    name: "brands___en"
  }, {
    path: "/en/career",
    component: _65b7751a,
    pathToRegexpOptions: {"strict":true},
    name: "career___en"
  }, {
    path: "/en/contacts",
    component: _09408b6f,
    pathToRegexpOptions: {"strict":true},
    name: "contacts___en"
  }, {
    path: "/en/feedbacks",
    component: _7916fb88,
    pathToRegexpOptions: {"strict":true},
    name: "feedbacks___en"
  }, {
    path: "/en/gallery",
    component: _2f58140c,
    pathToRegexpOptions: {"strict":true},
    name: "gallery___en"
  }, {
    path: "/en/logistics",
    component: _16822dcd,
    pathToRegexpOptions: {"strict":true},
    name: "logistics___en"
  }, {
    path: "/en/partners",
    component: _678c59c7,
    pathToRegexpOptions: {"strict":true},
    name: "partners___en"
  }, {
    path: "/en/ui-kit-demo",
    component: _4a0f5aec,
    pathToRegexpOptions: {"strict":true},
    name: "ui-kit-demo___en"
  }, {
    path: "/en/want-to-order",
    component: _cd7bfd5a,
    pathToRegexpOptions: {"strict":true},
    name: "want-to-order___en"
  }, {
    path: "/ro/404",
    component: _ef8fc2a2,
    pathToRegexpOptions: {"strict":true},
    name: "404___ro"
  }, {
    path: "/ro/about",
    component: _e3692372,
    pathToRegexpOptions: {"strict":true},
    name: "about___ro"
  }, {
    path: "/ro/articles",
    component: _dbf3be4e,
    pathToRegexpOptions: {"strict":true},
    name: "articles___ro"
  }, {
    path: "/ro/brands",
    component: _6bcb89e8,
    pathToRegexpOptions: {"strict":true},
    name: "brands___ro"
  }, {
    path: "/ro/career",
    component: _65b7751a,
    pathToRegexpOptions: {"strict":true},
    name: "career___ro"
  }, {
    path: "/ro/contacts",
    component: _09408b6f,
    pathToRegexpOptions: {"strict":true},
    name: "contacts___ro"
  }, {
    path: "/ro/feedbacks",
    component: _7916fb88,
    pathToRegexpOptions: {"strict":true},
    name: "feedbacks___ro"
  }, {
    path: "/ro/gallery",
    component: _2f58140c,
    pathToRegexpOptions: {"strict":true},
    name: "gallery___ro"
  }, {
    path: "/ro/logistics",
    component: _16822dcd,
    pathToRegexpOptions: {"strict":true},
    name: "logistics___ro"
  }, {
    path: "/ro/partners",
    component: _678c59c7,
    pathToRegexpOptions: {"strict":true},
    name: "partners___ro"
  }, {
    path: "/ro/ui-kit-demo",
    component: _4a0f5aec,
    pathToRegexpOptions: {"strict":true},
    name: "ui-kit-demo___ro"
  }, {
    path: "/ro/want-to-order",
    component: _cd7bfd5a,
    pathToRegexpOptions: {"strict":true},
    name: "want-to-order___ro"
  }, {
    path: "/ru/404",
    component: _ef8fc2a2,
    pathToRegexpOptions: {"strict":true},
    name: "404___ru"
  }, {
    path: "/ru/about",
    component: _e3692372,
    pathToRegexpOptions: {"strict":true},
    name: "about___ru"
  }, {
    path: "/ru/articles",
    component: _dbf3be4e,
    pathToRegexpOptions: {"strict":true},
    name: "articles___ru"
  }, {
    path: "/ru/brands",
    component: _6bcb89e8,
    pathToRegexpOptions: {"strict":true},
    name: "brands___ru"
  }, {
    path: "/ru/career",
    component: _65b7751a,
    pathToRegexpOptions: {"strict":true},
    name: "career___ru"
  }, {
    path: "/ru/contacts",
    component: _09408b6f,
    pathToRegexpOptions: {"strict":true},
    name: "contacts___ru"
  }, {
    path: "/ru/feedbacks",
    component: _7916fb88,
    pathToRegexpOptions: {"strict":true},
    name: "feedbacks___ru"
  }, {
    path: "/ru/gallery",
    component: _2f58140c,
    pathToRegexpOptions: {"strict":true},
    name: "gallery___ru"
  }, {
    path: "/ru/logistics",
    component: _16822dcd,
    pathToRegexpOptions: {"strict":true},
    name: "logistics___ru"
  }, {
    path: "/ru/partners",
    component: _678c59c7,
    pathToRegexpOptions: {"strict":true},
    name: "partners___ru"
  }, {
    path: "/ru/ui-kit-demo",
    component: _4a0f5aec,
    pathToRegexpOptions: {"strict":true},
    name: "ui-kit-demo___ru"
  }, {
    path: "/ru/want-to-order",
    component: _cd7bfd5a,
    pathToRegexpOptions: {"strict":true},
    name: "want-to-order___ru"
  }, {
    path: "/uk/404",
    component: _ef8fc2a2,
    pathToRegexpOptions: {"strict":true},
    name: "404___uk"
  }, {
    path: "/uk/about",
    component: _e3692372,
    pathToRegexpOptions: {"strict":true},
    name: "about___uk"
  }, {
    path: "/uk/articles",
    component: _dbf3be4e,
    pathToRegexpOptions: {"strict":true},
    name: "articles___uk"
  }, {
    path: "/uk/brands",
    component: _6bcb89e8,
    pathToRegexpOptions: {"strict":true},
    name: "brands___uk"
  }, {
    path: "/uk/career",
    component: _65b7751a,
    pathToRegexpOptions: {"strict":true},
    name: "career___uk"
  }, {
    path: "/uk/contacts",
    component: _09408b6f,
    pathToRegexpOptions: {"strict":true},
    name: "contacts___uk"
  }, {
    path: "/uk/feedbacks",
    component: _7916fb88,
    pathToRegexpOptions: {"strict":true},
    name: "feedbacks___uk"
  }, {
    path: "/uk/gallery",
    component: _2f58140c,
    pathToRegexpOptions: {"strict":true},
    name: "gallery___uk"
  }, {
    path: "/uk/logistics",
    component: _16822dcd,
    pathToRegexpOptions: {"strict":true},
    name: "logistics___uk"
  }, {
    path: "/uk/partners",
    component: _678c59c7,
    pathToRegexpOptions: {"strict":true},
    name: "partners___uk"
  }, {
    path: "/uk/ui-kit-demo",
    component: _4a0f5aec,
    pathToRegexpOptions: {"strict":true},
    name: "ui-kit-demo___uk"
  }, {
    path: "/uk/want-to-order",
    component: _cd7bfd5a,
    pathToRegexpOptions: {"strict":true},
    name: "want-to-order___uk"
  }, {
    path: "/en/about/types",
    component: _7287a761,
    pathToRegexpOptions: {"strict":true},
    name: "about-types___en"
  }, {
    path: "/en/articles/types",
    component: _33794ae2,
    pathToRegexpOptions: {"strict":true},
    name: "articles-types___en"
  }, {
    path: "/en/gallery/types",
    component: _041cb4fc,
    pathToRegexpOptions: {"strict":true},
    name: "gallery-types___en"
  }, {
    path: "/en/want-to-order/types",
    component: _c7a6fa56,
    pathToRegexpOptions: {"strict":true},
    name: "want-to-order-types___en"
  }, {
    path: "/ro/about/types",
    component: _7287a761,
    pathToRegexpOptions: {"strict":true},
    name: "about-types___ro"
  }, {
    path: "/ro/articles/types",
    component: _33794ae2,
    pathToRegexpOptions: {"strict":true},
    name: "articles-types___ro"
  }, {
    path: "/ro/gallery/types",
    component: _041cb4fc,
    pathToRegexpOptions: {"strict":true},
    name: "gallery-types___ro"
  }, {
    path: "/ro/want-to-order/types",
    component: _c7a6fa56,
    pathToRegexpOptions: {"strict":true},
    name: "want-to-order-types___ro"
  }, {
    path: "/ru/about/types",
    component: _7287a761,
    pathToRegexpOptions: {"strict":true},
    name: "about-types___ru"
  }, {
    path: "/ru/articles/types",
    component: _33794ae2,
    pathToRegexpOptions: {"strict":true},
    name: "articles-types___ru"
  }, {
    path: "/ru/gallery/types",
    component: _041cb4fc,
    pathToRegexpOptions: {"strict":true},
    name: "gallery-types___ru"
  }, {
    path: "/ru/want-to-order/types",
    component: _c7a6fa56,
    pathToRegexpOptions: {"strict":true},
    name: "want-to-order-types___ru"
  }, {
    path: "/uk/about/types",
    component: _7287a761,
    pathToRegexpOptions: {"strict":true},
    name: "about-types___uk"
  }, {
    path: "/uk/articles/types",
    component: _33794ae2,
    pathToRegexpOptions: {"strict":true},
    name: "articles-types___uk"
  }, {
    path: "/uk/gallery/types",
    component: _041cb4fc,
    pathToRegexpOptions: {"strict":true},
    name: "gallery-types___uk"
  }, {
    path: "/uk/want-to-order/types",
    component: _c7a6fa56,
    pathToRegexpOptions: {"strict":true},
    name: "want-to-order-types___uk"
  }, {
    path: "/en/about/components/AchievementMessage",
    component: _8cb822ee,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-AchievementMessage___en"
  }, {
    path: "/en/about/components/Gallery",
    component: _aa829bd2,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-Gallery___en"
  }, {
    path: "/en/about/components/HangAchievements",
    component: _97bf6d32,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-HangAchievements___en"
  }, {
    path: "/en/about/components/MediaInfoBlock",
    component: _95a21e28,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-MediaInfoBlock___en"
  }, {
    path: "/en/articles/components/ItemsLarge",
    component: _604c0b5e,
    pathToRegexpOptions: {"strict":true},
    name: "articles-components-ItemsLarge___en"
  }, {
    path: "/en/articles/components/ItemsSmall",
    component: _6491d3ac,
    pathToRegexpOptions: {"strict":true},
    name: "articles-components-ItemsSmall___en"
  }, {
    path: "/en/articles/components/MySkeletonNews",
    component: _4f17fb4f,
    pathToRegexpOptions: {"strict":true},
    name: "articles-components-MySkeletonNews___en"
  }, {
    path: "/en/gallery/components/GalleryItem",
    component: _430d67b6,
    pathToRegexpOptions: {"strict":true},
    name: "gallery-components-GalleryItem___en"
  }, {
    path: "/en/logistics/components/ContentImageBlock",
    component: _61b27a8a,
    pathToRegexpOptions: {"strict":true},
    name: "logistics-components-ContentImageBlock___en"
  }, {
    path: "/ro/about/components/AchievementMessage",
    component: _8cb822ee,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-AchievementMessage___ro"
  }, {
    path: "/ro/about/components/Gallery",
    component: _aa829bd2,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-Gallery___ro"
  }, {
    path: "/ro/about/components/HangAchievements",
    component: _97bf6d32,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-HangAchievements___ro"
  }, {
    path: "/ro/about/components/MediaInfoBlock",
    component: _95a21e28,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-MediaInfoBlock___ro"
  }, {
    path: "/ro/articles/components/ItemsLarge",
    component: _604c0b5e,
    pathToRegexpOptions: {"strict":true},
    name: "articles-components-ItemsLarge___ro"
  }, {
    path: "/ro/articles/components/ItemsSmall",
    component: _6491d3ac,
    pathToRegexpOptions: {"strict":true},
    name: "articles-components-ItemsSmall___ro"
  }, {
    path: "/ro/articles/components/MySkeletonNews",
    component: _4f17fb4f,
    pathToRegexpOptions: {"strict":true},
    name: "articles-components-MySkeletonNews___ro"
  }, {
    path: "/ro/gallery/components/GalleryItem",
    component: _430d67b6,
    pathToRegexpOptions: {"strict":true},
    name: "gallery-components-GalleryItem___ro"
  }, {
    path: "/ro/logistics/components/ContentImageBlock",
    component: _61b27a8a,
    pathToRegexpOptions: {"strict":true},
    name: "logistics-components-ContentImageBlock___ro"
  }, {
    path: "/ru/about/components/AchievementMessage",
    component: _8cb822ee,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-AchievementMessage___ru"
  }, {
    path: "/ru/about/components/Gallery",
    component: _aa829bd2,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-Gallery___ru"
  }, {
    path: "/ru/about/components/HangAchievements",
    component: _97bf6d32,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-HangAchievements___ru"
  }, {
    path: "/ru/about/components/MediaInfoBlock",
    component: _95a21e28,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-MediaInfoBlock___ru"
  }, {
    path: "/ru/articles/components/ItemsLarge",
    component: _604c0b5e,
    pathToRegexpOptions: {"strict":true},
    name: "articles-components-ItemsLarge___ru"
  }, {
    path: "/ru/articles/components/ItemsSmall",
    component: _6491d3ac,
    pathToRegexpOptions: {"strict":true},
    name: "articles-components-ItemsSmall___ru"
  }, {
    path: "/ru/articles/components/MySkeletonNews",
    component: _4f17fb4f,
    pathToRegexpOptions: {"strict":true},
    name: "articles-components-MySkeletonNews___ru"
  }, {
    path: "/ru/gallery/components/GalleryItem",
    component: _430d67b6,
    pathToRegexpOptions: {"strict":true},
    name: "gallery-components-GalleryItem___ru"
  }, {
    path: "/ru/logistics/components/ContentImageBlock",
    component: _61b27a8a,
    pathToRegexpOptions: {"strict":true},
    name: "logistics-components-ContentImageBlock___ru"
  }, {
    path: "/uk/about/components/AchievementMessage",
    component: _8cb822ee,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-AchievementMessage___uk"
  }, {
    path: "/uk/about/components/Gallery",
    component: _aa829bd2,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-Gallery___uk"
  }, {
    path: "/uk/about/components/HangAchievements",
    component: _97bf6d32,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-HangAchievements___uk"
  }, {
    path: "/uk/about/components/MediaInfoBlock",
    component: _95a21e28,
    pathToRegexpOptions: {"strict":true},
    name: "about-components-MediaInfoBlock___uk"
  }, {
    path: "/uk/articles/components/ItemsLarge",
    component: _604c0b5e,
    pathToRegexpOptions: {"strict":true},
    name: "articles-components-ItemsLarge___uk"
  }, {
    path: "/uk/articles/components/ItemsSmall",
    component: _6491d3ac,
    pathToRegexpOptions: {"strict":true},
    name: "articles-components-ItemsSmall___uk"
  }, {
    path: "/uk/articles/components/MySkeletonNews",
    component: _4f17fb4f,
    pathToRegexpOptions: {"strict":true},
    name: "articles-components-MySkeletonNews___uk"
  }, {
    path: "/uk/gallery/components/GalleryItem",
    component: _430d67b6,
    pathToRegexpOptions: {"strict":true},
    name: "gallery-components-GalleryItem___uk"
  }, {
    path: "/uk/logistics/components/ContentImageBlock",
    component: _61b27a8a,
    pathToRegexpOptions: {"strict":true},
    name: "logistics-components-ContentImageBlock___uk"
  }, {
    path: "/en/logistics/components/ContentImageBlock/types",
    component: _05bc86be,
    pathToRegexpOptions: {"strict":true},
    name: "logistics-components-ContentImageBlock-types___en"
  }, {
    path: "/ro/logistics/components/ContentImageBlock/types",
    component: _05bc86be,
    pathToRegexpOptions: {"strict":true},
    name: "logistics-components-ContentImageBlock-types___ro"
  }, {
    path: "/ru/logistics/components/ContentImageBlock/types",
    component: _05bc86be,
    pathToRegexpOptions: {"strict":true},
    name: "logistics-components-ContentImageBlock-types___ru"
  }, {
    path: "/uk/logistics/components/ContentImageBlock/types",
    component: _05bc86be,
    pathToRegexpOptions: {"strict":true},
    name: "logistics-components-ContentImageBlock-types___uk"
  }, {
    path: "/en/articles/:url",
    component: _71a12288,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url___en"
  }, {
    path: "/en/gallery/:id",
    component: _54b048f7,
    pathToRegexpOptions: {"strict":true},
    name: "gallery-id___en"
  }, {
    path: "/en/product/:product",
    component: _5c2f72a8,
    pathToRegexpOptions: {"strict":true},
    name: "product-product___en"
  }, {
    path: "/ro/articles/:url",
    component: _71a12288,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url___ro"
  }, {
    path: "/ro/gallery/:id",
    component: _54b048f7,
    pathToRegexpOptions: {"strict":true},
    name: "gallery-id___ro"
  }, {
    path: "/ro/product/:product",
    component: _5c2f72a8,
    pathToRegexpOptions: {"strict":true},
    name: "product-product___ro"
  }, {
    path: "/ru/articles/:url",
    component: _71a12288,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url___ru"
  }, {
    path: "/ru/gallery/:id",
    component: _54b048f7,
    pathToRegexpOptions: {"strict":true},
    name: "gallery-id___ru"
  }, {
    path: "/ru/product/:product",
    component: _5c2f72a8,
    pathToRegexpOptions: {"strict":true},
    name: "product-product___ru"
  }, {
    path: "/uk/articles/:url",
    component: _71a12288,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url___uk"
  }, {
    path: "/uk/gallery/:id",
    component: _54b048f7,
    pathToRegexpOptions: {"strict":true},
    name: "gallery-id___uk"
  }, {
    path: "/uk/product/:product",
    component: _5c2f72a8,
    pathToRegexpOptions: {"strict":true},
    name: "product-product___uk"
  }, {
    path: "/en/articles/:url/types",
    component: _5b97444c,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-types___en"
  }, {
    path: "/en/product/:product?/types",
    component: _4b6bae5c,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-types___en"
  }, {
    path: "/ro/articles/:url/types",
    component: _5b97444c,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-types___ro"
  }, {
    path: "/ro/product/:product?/types",
    component: _4b6bae5c,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-types___ro"
  }, {
    path: "/ru/articles/:url/types",
    component: _5b97444c,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-types___ru"
  }, {
    path: "/ru/product/:product?/types",
    component: _4b6bae5c,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-types___ru"
  }, {
    path: "/uk/articles/:url/types",
    component: _5b97444c,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-types___uk"
  }, {
    path: "/uk/product/:product?/types",
    component: _4b6bae5c,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-types___uk"
  }, {
    path: "/en/articles/:url/components/Banner",
    component: _1da44d12,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Banner___en"
  }, {
    path: "/en/articles/:url/components/Content",
    component: _0b0b63e9,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Content___en"
  }, {
    path: "/en/articles/:url/components/Video",
    component: _016d8aab,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Video___en"
  }, {
    path: "/en/product/:product?/components/Characteristics",
    component: _79a14bf8,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Characteristics___en"
  }, {
    path: "/en/product/:product?/components/Product",
    component: _74f922ef,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product___en"
  }, {
    path: "/en/product/:product?/components/Video",
    component: _e93cde8a,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Video___en"
  }, {
    path: "/ro/articles/:url/components/Banner",
    component: _1da44d12,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Banner___ro"
  }, {
    path: "/ro/articles/:url/components/Content",
    component: _0b0b63e9,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Content___ro"
  }, {
    path: "/ro/articles/:url/components/Video",
    component: _016d8aab,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Video___ro"
  }, {
    path: "/ro/product/:product?/components/Characteristics",
    component: _79a14bf8,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Characteristics___ro"
  }, {
    path: "/ro/product/:product?/components/Product",
    component: _74f922ef,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product___ro"
  }, {
    path: "/ro/product/:product?/components/Video",
    component: _e93cde8a,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Video___ro"
  }, {
    path: "/ru/articles/:url/components/Banner",
    component: _1da44d12,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Banner___ru"
  }, {
    path: "/ru/articles/:url/components/Content",
    component: _0b0b63e9,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Content___ru"
  }, {
    path: "/ru/articles/:url/components/Video",
    component: _016d8aab,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Video___ru"
  }, {
    path: "/ru/product/:product?/components/Characteristics",
    component: _79a14bf8,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Characteristics___ru"
  }, {
    path: "/ru/product/:product?/components/Product",
    component: _74f922ef,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product___ru"
  }, {
    path: "/ru/product/:product?/components/Video",
    component: _e93cde8a,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Video___ru"
  }, {
    path: "/uk/articles/:url/components/Banner",
    component: _1da44d12,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Banner___uk"
  }, {
    path: "/uk/articles/:url/components/Content",
    component: _0b0b63e9,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Content___uk"
  }, {
    path: "/uk/articles/:url/components/Video",
    component: _016d8aab,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Video___uk"
  }, {
    path: "/uk/product/:product?/components/Characteristics",
    component: _79a14bf8,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Characteristics___uk"
  }, {
    path: "/uk/product/:product?/components/Product",
    component: _74f922ef,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product___uk"
  }, {
    path: "/uk/product/:product?/components/Video",
    component: _e93cde8a,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Video___uk"
  }, {
    path: "/en/articles/:url/components/Banner/skeleton",
    component: _8fbc9e86,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Banner-skeleton___en"
  }, {
    path: "/en/articles/:url/components/Content/skeleton",
    component: _f086d2f4,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Content-skeleton___en"
  }, {
    path: "/en/articles/:url/components/Video/skeleton",
    component: _6fb8e084,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Video-skeleton___en"
  }, {
    path: "/ro/articles/:url/components/Banner/skeleton",
    component: _8fbc9e86,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Banner-skeleton___ro"
  }, {
    path: "/ro/articles/:url/components/Content/skeleton",
    component: _f086d2f4,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Content-skeleton___ro"
  }, {
    path: "/ro/articles/:url/components/Video/skeleton",
    component: _6fb8e084,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Video-skeleton___ro"
  }, {
    path: "/ru/articles/:url/components/Banner/skeleton",
    component: _8fbc9e86,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Banner-skeleton___ru"
  }, {
    path: "/ru/articles/:url/components/Content/skeleton",
    component: _f086d2f4,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Content-skeleton___ru"
  }, {
    path: "/ru/articles/:url/components/Video/skeleton",
    component: _6fb8e084,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Video-skeleton___ru"
  }, {
    path: "/uk/articles/:url/components/Banner/skeleton",
    component: _8fbc9e86,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Banner-skeleton___uk"
  }, {
    path: "/uk/articles/:url/components/Content/skeleton",
    component: _f086d2f4,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Content-skeleton___uk"
  }, {
    path: "/uk/articles/:url/components/Video/skeleton",
    component: _6fb8e084,
    pathToRegexpOptions: {"strict":true},
    name: "articles-url-components-Video-skeleton___uk"
  }, {
    path: "/en/product/:product?/components/Product/components/PanelBoard",
    component: _09aa201b,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product-components-PanelBoard___en"
  }, {
    path: "/en/product/:product?/components/Product/components/ScreenSlider",
    component: _554b47f4,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product-components-ScreenSlider___en"
  }, {
    path: "/ro/product/:product?/components/Product/components/PanelBoard",
    component: _09aa201b,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product-components-PanelBoard___ro"
  }, {
    path: "/ro/product/:product?/components/Product/components/ScreenSlider",
    component: _554b47f4,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product-components-ScreenSlider___ro"
  }, {
    path: "/ru/product/:product?/components/Product/components/PanelBoard",
    component: _09aa201b,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product-components-PanelBoard___ru"
  }, {
    path: "/ru/product/:product?/components/Product/components/ScreenSlider",
    component: _554b47f4,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product-components-ScreenSlider___ru"
  }, {
    path: "/uk/product/:product?/components/Product/components/PanelBoard",
    component: _09aa201b,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product-components-PanelBoard___uk"
  }, {
    path: "/uk/product/:product?/components/Product/components/ScreenSlider",
    component: _554b47f4,
    pathToRegexpOptions: {"strict":true},
    name: "product-product-components-Product-components-ScreenSlider___uk"
  }, {
    path: "/en/brands/*",
    component: _21897c16,
    pathToRegexpOptions: {"strict":true},
    name: "brands-all___en"
  }, {
    path: "/uk/brands/*",
    component: _21897c16,
    pathToRegexpOptions: {"strict":true},
    name: "brands-all___uk"
  }, {
    path: "/ru/brands/*",
    component: _21897c16,
    pathToRegexpOptions: {"strict":true},
    name: "brands-all___ru"
  }, {
    path: "/ro/brands/*",
    component: _21897c16,
    pathToRegexpOptions: {"strict":true},
    name: "brands-all___ro"
  }, {
    path: "/en/*",
    component: _17499616,
    pathToRegexpOptions: {"strict":true},
    name: "all___en"
  }, {
    path: "/uk/*",
    component: _17499616,
    pathToRegexpOptions: {"strict":true},
    name: "all___uk"
  }, {
    path: "/ru/*",
    component: _17499616,
    pathToRegexpOptions: {"strict":true},
    name: "all___ru"
  }, {
    path: "/ro/*",
    component: _17499616,
    pathToRegexpOptions: {"strict":true},
    name: "all___ro"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
